import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin} from 'lucide-react';
import { companyInfo } from '../mockData';

const scrollToTop =() => {
  if (typeof window !== 'undefined') { window.scrollTo({ top: 0, behaviour: 'smooth' }); }
};
const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src="/favicon.png" alt='logo' className="w-10 h-10 rounded-lg" />
              <h3 className="text-lg font-bold">{companyInfo.name}</h3>
            </div>
            <p className="text-gray-300 text-sm mb-4 leading-relaxed">
              {companyInfo.tagline}
            </p>

          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" onClick={scrollToTop} className="text-gray-300 hover:text-white transition-colors text-sm">Home</Link></li>
              <li><Link to="/products" onClick={scrollToTop} className="text-gray-300 hover:text-white transition-colors text-sm">Products</Link></li>
              <li><Link to="/about" onClick={scrollToTop} className="text-gray-300 hover:text-white transition-colors text-sm">About Us</Link></li>
              <li><Link to="/partners" onClick={scrollToTop} className="text-gray-300 hover:text-white transition-colors text-sm">Our Partners</Link></li>
              <li><Link to="/contact" onClick={scrollToTop} className="text-gray-300 hover:text-white transition-colors text-sm">Contact</Link></li>
              <li><Link to="/become-partner" onClick={scrollToTop} className="text-gray-300 hover:text-white transition-colors text-sm">Become a Partner</Link></li>
            </ul>
          </div>

          {/* Product Categories */}

          <div>
            <h4 className="text-lg font-semibold mb-4">Product Categories</h4>
            <ul className="space-y-2">
              <li><Link to="/products?category=gastrointestinal" onClick={scrollToTop} className="text-gray-300 hover:text-white transition-colors text-sm">Gastrointestinal</Link></li>
              <li><Link to="/products?category=Multivitamins" onClick={scrollToTop} className="text-gray-300 hover:text-white transition-colors text-sm">Multivitamins</Link></li>
              <li><Link to="/products?category=antibiotics" onClick={scrollToTop} className="text-gray-300 hover:text-white transition-colors text-sm">Antibiotics</Link></li>
              <li><Link to="/products?category=pain-relief" onClick={scrollToTop} className="text-gray-300 hover:text-white transition-colors text-sm">Pain Relief</Link></li>
              <li><Link to="/products?category=neurological" onClick={scrollToTop} className="text-gray-300 hover:text-white transition-colors text-sm">Neurological</Link></li>
              <li><Link to="/products?category=bone-health" onClick={scrollToTop} className="text-gray-300 hover:text-white transition-colors text-sm">Bone Health</Link></li>
              <li><Link to="/products?category=womens-health" onClick={scrollToTop} className="text-gray-300 hover:text-white transition-colors text-sm">Women's Health</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-blue-400 flex-shrink-0 mt-1" />
                <p className="text-gray-300 text-sm leading-relaxed">
                  {companyInfo.corporateOffice.address}
                </p>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-blue-400 flex-shrink-0" />
                <a href={`tel:${companyInfo.corporateOffice.phone}`} className="text-gray-300 hover:text-white transition-colors text-sm">
                  {companyInfo.corporateOffice.phone}
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-blue-400 flex-shrink-0" />
                <a href={`mailto:${companyInfo.corporateOffice.email}`} className="text-gray-300 hover:text-white transition-colors text-sm break-all">
                  {companyInfo.corporateOffice.email}
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Certifications */}
        <div className="border-t border-blue-800 pt-6 mb-6">
          <div className="flex flex-wrap justify-center gap-4 mb-4">
            {companyInfo.certifications.map((cert, index) => (
              <div key={index} className="bg-blue-800 px-4 py-2 rounded-lg text-sm font-medium">
                {cert}
              </div>
            ))}
          </div>
          <p className="text-center text-gray-400 text-xs">
            {companyInfo.manufacturing}
          </p>
        </div>

        {/* Copyright */}
        <div className="border-t border-blue-800 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <Link to="/privacy" onClick={scrollToTop} className="text-gray-400 hover:text-white transition-colors">Privacy Policy</Link>
              <Link to="/terms" onClick={scrollToTop} className="text-gray-400 hover:text-white transition-colors">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
